import React from "react";
import { Tooltip } from "antd";
import { RiMapPinUserLine } from "react-icons/ri";
import { countOffSite, offSiteLabel } from "../utils/offSite";
import {
  ACCENT,
  INK,
  LINE,
  SURFACE,
  neutralText,
  onActivateKey,
} from "./layerStyle";
import "./layerControls.css";

const chipStyle = {
  ...neutralText,
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  flexShrink: 0,
  padding: "0 8px",
  lineHeight: "22px",
  border: `1px solid ${LINE}`,
  borderRadius: 11,
  backgroundColor: SURFACE,
  color: INK,
  fontVariantNumeric: "tabular-nums",
  fontWeight: "normal",
  userSelect: "none",
  "--iot3-layer-accent": ACCENT,
};

/**
 * A canvas card's title (live dashboard, replay, widget) with 「場外：N 人、M
 * 機具」 right of it whenever anyone is off site (D-29). With `onFit` the
 * chip zooms the canvas out to fit the site and every off-site item; without
 * it (a line/tunnel strip, no zoom) it is information only.
 */
const OffSiteTitle = ({ title, personnel, equipment, onFit }) => {
  const { people, machines } = countOffSite(personnel, equipment);
  const label = offSiteLabel(people, machines);
  const chip = (
    <span
      className={onFit ? "iot3-offsite-status" : undefined}
      {...(onFit
        ? {
            role: "button",
            tabIndex: 0,
            onClick: onFit,
            onKeyDown: onActivateKey(onFit),
          }
        : {})}
      style={{ ...chipStyle, cursor: onFit ? "pointer" : "default" }}
    >
      <RiMapPinUserLine aria-hidden="true" style={{ fontSize: 14 }} />
      {label}
    </span>
  );
  return (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        minWidth: 0,
      }}
    >
      <span
        style={{
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {title}
      </span>
      {(people > 0 || machines > 0) &&
        (onFit ? (
          <Tooltip title="縮放畫面以顯示場外人員與機具">{chip}</Tooltip>
        ) : (
          chip
        ))}
    </span>
  );
};

export default OffSiteTitle;
